import { useEffect } from "react";
import { useLocation } from "react-router";

import type { NavigationItem } from "../Sidebar.types";
import { subNavigationActions } from "../SubNavigation.store";

export const useSidebarNavigation = (
  navigationItems: NavigationItem[],
  homePath: string,
) => {
  const location = useLocation();

  const getActivePage = (href: string, item: NavigationItem) => {
    if (item.isActive) {
      return item.isActive(location.pathname);
    }

    if (href === homePath) {
      return location.pathname === homePath;
    }

    if (item.isMainContent != null && item.isMainContent) {
      return location.pathname === href;
    }

    const hasActiveMainContent = navigationItems.some(
      (navItem) =>
        navItem.isMainContent === true && location.pathname === navItem.href,
    );

    return (
      location.pathname === href ||
      (!hasActiveMainContent && location.pathname.startsWith(href))
    );
  };

  useEffect(() => {
    const activeItem = navigationItems.find(
      (item) => item.isMainContent === true && location.pathname === item.href,
    );
    subNavigationActions.setActiveItem(activeItem);
  }, [location.pathname, navigationItems]);

  return {
    getActivePage,
  };
};
